export default {
  surveyAnswer: '/v3/question/survey/courier/answer'
}
